import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Dropdown,
  Input,
  Checkbox,
  TextArea
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardPostOperationUX = (props: any) => {
    return(
      <div
        id="CardPostOperation"
        style={{ margin: "15px", padding: "20px", backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardPostOperationUX-div-1"
          style={{ paddingBottom: "0px", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          
          <label
            id="CardPostOperationUX-label-2"
            style={{ fontWeight: "bold", fontSize: "22px" }}>
            {props.languageUX === "en" ? "Operative Note" : "Operative Note"}
          </label>
          <Button
            id="CardPostOperationUX-Button-3">
            
          </Button>
        </div>
        <hr
          id="CardPostOperationUX-hr-5">
        </hr>
        <div
          id="CardPostOperationUX-div-6"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px", fontWeight: "bold" }}>
          
          <div
            id="CardPostOperationUX-div-14"
            style={{ width: "20%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardPostOperationUX-label-15">
              {props.languageUX === "en" ? "Date of Operation" : "วันที่ผ่าตัด"}
            </label>
            <label
              id="CardPostOperationUX-label-16"
              style={{marginLeft: "20px"}}>
              {props.operatingDetail?.incision_date}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-17"
            style={{ width: "20%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardPostOperationUX-label-18">
              {props.languageUX === "en" ? "Operative time" : "เวลาผ่าตัด"}
            </label>
            <label
              id="CardPostOperationUX-label-19"
              style={{marginLeft: "20px"}}>
              {props.operatingDetail?.incision_datetime}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-12"
            style={{display: "flex", width: "25%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardPostOperationUX-label-24"
              style={{display: "flex", alignItems: "center" }}>
              {props.languageUX === "en" ? "Swab Instrument" : "อุปกรณ์ Swab "}
            </label>
            <div
              id="CardPostOperationUX-div-21"
              style={{width: "60%", paddingLeft: "20px"}}>
              
              <Dropdown
                fluid={true}
                id="CardPostOperationUX-Dropdown-22"
                name="swab_instrument_status"
                onChange={props.onChangeData}
                options={props.swabOptions}
                selection={true}
                value={props.teamDetail?.swab_instrument_status || ""}>
              </Dropdown>
            </div>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-26"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px", fontWeight: "bold" }}>
          
          <div
            id="CardPostOperationUX-div-27"
            style={{margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardPostOperationUX-label-29">
              {props.languageUX === "en" ? "Team" : "ทีม"}
            </label>
            <label
              id="CardPostOperationUX-label-30"
              style={{color: "red"}}>
              *
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-28"
            style={{width: "60%", margin: "5px 10px 0px 0px" }}>
            
            <Dropdown
              fluid={true}
              id="CardPostOperationUX-Dropdown-31"
              name="id"
              onChange={props.onChangeTeam}
              options={props.chiefSurgeonOptions}
              selection={true}
              value={props.teamDetail?.id}>
            </Dropdown>
          </div>
        </div>
        <hr
          id="CardPostOperationUX-hr-32">
        </hr>
        <div
          id="CardPostOperationUX-div-33"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-34"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-35">
              {props.languageUX === "en" ? "Assistant Surgeon" : "ผู้ช่วยศัลยแพทย์"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-38"
            style={{width: "90%", margin: "5px 10px 0px 0px" }}>
            
            <div
              id="CardPostOperationUX-div-40">
              {props.teamDetail?.assistant_surgeons_summary}
            </div>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-41"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-42"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-45">
              {props.languageUX === "en" ? "Scrub Nurse" : "พยาบาล Scrub"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-43"
            style={{width: "90%", margin: "5px 10px 0px 0px" }}>
            
            <div
              id="CardPostOperationUX-div-44">
              {props.teamDetail?.scrub_nurse_summary}
            </div>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-46"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-47"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-50">
              {props.languageUX === "en" ? "Circulation Nurse" : "พยาบาล Circulation"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-48"
            style={{width: "90%", margin: "5px 10px 0px 0px" }}>
            
            <div
              id="CardPostOperationUX-div-49">
              {props.teamDetail?.circulating_nurse_summary}
            </div>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-51"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-52"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-55">
              {props.languageUX === "en" ? "Anesthesisologist" : "วิสัญญีแพทย์"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-53"
            style={{width: "90%", margin: "5px 10px 0px 0px"}}>
            
            <div
              id="CardPostOperationUX-div-54">
              {props.teamDetail?.anesthesiologist_summary}
            </div>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-56"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-57"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-60">
              {props.languageUX === "en" ? "Anesthesia nurse" : "พยาบาลวิสัญญี"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-58"
            style={{width: "90%", margin: "5px 10px 0px 0px"}}>
            
            <div
              id="CardPostOperationUX-div-59">
              {props.teamDetail?.anesthetist_summary}
            </div>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-61"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-62"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-64">
              {props.languageUX === "en" ? "Preoperative diagnosis" : "การวินิจฉัยโรคก่อนการผ่าตัด"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-63"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", backgroundColor: "rgba(255,255,255)"}}>
            
            <div
              id="CardPostOperationUX-div-65"
              style={{paddingBottom: "5px"}}>
              
              <label
                id="CardPostOperationUX-label-68"
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "Principle Diagnosis" : "การวินิจฉัยโรคหลัก"}
              </label>
            </div>
            <div
              id="CardPostOperationUX-div-66"
              style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
              
              <div
                id="CardPostOperationUX-div-69"
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  id="CardPostOperationUX-label-73"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Medical Term" : "Medical Term"}
                </label>
                <Input
                  fluid={true}
                  id="CardPostOperationUX-Input-77"
                  name="icd10_med_term"
                  onChange={props.onChangePrePrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd10_med_term || ""}>
                </Input>
              </div>
              <div
                id="CardPostOperationUX-div-70"
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  id="CardPostOperationUX-label-74"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "ICD10 Term" : "ICD10 Term"}
                </label>
                <Input
                  fluid={true}
                  id="CardPostOperationUX-Input-78"
                  name="icd_term"
                  onChange={props.onChangePrePrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd_term || ""}>
                </Input>
              </div>
              <div
                id="CardPostOperationUX-div-71"
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  id="CardPostOperationUX-label-75"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "ICD10 Code" : "ICD10 Code"}
                </label>
                <Input
                  fluid={true}
                  id="CardPostOperationUX-Input-79"
                  name="icd_code"
                  onChange={props.onChangePrePrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd_code || ""}>
                </Input>
              </div>
              <div
                id="CardPostOperationUX-div-72"
                style={{ margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <Checkbox
                  checked={props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.active_disease || false}
                  id="CardPostOperationUX-Checkbox-80"
                  name="active_disease"
                  onChange={props.onChangePreActive}
                  style={{margin: "0px 10px 0 0"}}>
                </Checkbox>
                <label
                  id="CardPostOperationUX-label-76"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Active Disease" : "โรคที่กำลังดำเนินอยู่"}
                </label>
                <Button
                  color="teal"
                  icon="erase"
                  id="CardPostOperationUX-Button-81"
                  size="mini"
                  style={{margin: "0px 10px"}}>
                </Button>
                <Button
                  color="red"
                  icon="minus"
                  id="CardPostOperationUX-Button-82"
                  size="mini"
                  style={{margin: "0px 0 0 10px"}}>
                </Button>
              </div>
            </div>
            <div
              id="CardPostOperationUX-div-258"
              style={{ display: props.openSearchPrePrincipal ? "block" : "none", zIndex: 100,  width: "calc(100% - 20px)", } }>
              
              <Table
                data={props.searchPostProcedures}
                getTrProps={props.prePrincipleDiagnosis}
                id="CardPostOperationUX-Table-259"
                keys="medterm,icdterm,icdcode"
                minRows="4"
                name="test"
                showPagination={false}
                style={{ height: "150px" }}>
              </Table>
            </div>
            <div
              id="CardPostOperationUX-div-67"
              style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
              
              <div
                className="ui form"
                id="CardPostOperationUX-div-84"
                style={{width: "100%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "start" }}>
                
                <div
                  id="CardPostOperationUX-div-246"
                  style={{fontWeight: "bold", width: "14%"}}>
                  
                  <label
                    id="CardPostOperationUX-label-247"
                    style={{fontWeight: "bold", width: "14%"}}>
                    {props.languageUX === "en" ? "Pre-Diagnosis Detail" : "รายละเอียดก่อนการวินิจฉัย"}
                  </label>
                </div>
                <div
                  id="CardPostOperationUX-div-90"
                  style={{width: "65%"}}>
                  
                  <TextArea
                    id="CardPostOperationUX-TextArea-245"
                    name="detail.post_op_pre_diagnosis_remark"
                    onChange={props.onChangeData}
                    style={{margin: "0px 10px", width: "100%"}}
                    value={props.teamDetail?.detail?.post_op_pre_diagnosis_remark|| ""}>
                  </TextArea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-92"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-93"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-98">
              {props.languageUX === "en" ? "Postoperative diagnosis" : "การวินิจฉัยโรคหลังการผ่าตัด"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-94"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "15px", backgroundColor: "rgba(245,245,245)"}}>
            
            <div
              id="CardPostOperationUX-div-95"
              style={{paddingBottom: "5px"}}>
              
              <label
                id="CardPostOperationUX-label-99"
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "Principle Diagnosis" : "การวินิจฉัยโรคหลัก"}
              </label>
              <label
                id="CardPostOperationUX-label-244"
                style={{ color: "red" }}>
                *
              </label>
            </div>
            <div
              id="CardPostOperationUX-div-96"
              style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
              
              <div
                id="CardPostOperationUX-div-100"
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  id="CardPostOperationUX-label-104"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Medical Term" : "Medical Term"}
                </label>
                <Input
                  fluid={true}
                  id="CardPostOperationUX-Input-108"
                  name="icd10_med_term"
                  onChange={props.onChangePostPrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_principal_diagnosis[0]?.icd10_med_term || ""}>
                </Input>
              </div>
              <div
                id="CardPostOperationUX-div-101"
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  id="CardPostOperationUX-label-105"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "ICD10 Term" : "ICD10 Term"}
                </label>
                <Input
                  fluid={true}
                  id="CardPostOperationUX-Input-109"
                  name="icd_term"
                  onChange={props.onChangePostPrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_principal_diagnosis[0]?.icd_term || ""}>
                </Input>
              </div>
              <div
                id="CardPostOperationUX-div-102"
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  id="CardPostOperationUX-label-106"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "ICD10 Code" : "ICD10 Code"}
                </label>
                <Input
                  fluid={true}
                  id="CardPostOperationUX-Input-110"
                  name="icd_code"
                  onChange={props.onChangePostPrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_principal_diagnosis[0]?.icd_code || ""}>
                </Input>
              </div>
              <div
                id="CardPostOperationUX-div-103"
                style={{margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <Checkbox
                  checked={props.teamDetail?.post_principal_diagnosis[0]?.active_disease || false}
                  id="CardPostOperationUX-Checkbox-111"
                  name="active_disease"
                  onChange={props.onChangePostPrincipal}
                  style={{margin: "0px 10px 0 0"}}>
                </Checkbox>
                <label
                  id="CardPostOperationUX-label-107"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Active Disease" : "โรคที่กำลังดำเนินอยู่"}
                </label>
                <Button
                  color="teal"
                  icon="erase"
                  id="CardPostOperationUX-Button-112"
                  onClick={props.clearPrinciple}
                  size="mini"
                  style={{margin: "0px 10px"}}>
                </Button>
                <Button
                  color="red"
                  icon="minus"
                  id="CardPostOperationUX-Button-113"
                  onClick={props.clearPrinciple}
                  size="mini"
                  style={{margin: "0px 0 0 10px"}}>
                </Button>
              </div>
            </div>
            <div
              id="CardPostOperationUX-div-233"
              style={{ display: props.openSearchPostPrincipal ? "block" : "none", zIndex: 100,  width: "calc(100% - 20px)", } }>
              
              <Table
                data={props.searchPostProcedures}
                getTrProps={props.postPrincipleDiagnosis}
                id="CardPostOperationUX-Table-234"
                keys="medterm,icdterm,icdcode"
                minRows="4"
                showPagination={false}
                style={{ height: "150px" }}>
              </Table>
            </div>
            <div
              id="CardPostOperationUX-div-223"
              style={{...(props.secondary_style || {})}}>
              
              <label
                id="CardPostOperationUX-label-224"
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "Secondary Diagnosis" : "การวินิจฉัยโรครอง"}
              </label>
            </div>
            <div
              id="CardPostOperationUX-div-225">
              {props.secondaryDiagnosis}
            </div>
            <div
              id="CardPostOperationUX-div-97"
              style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" , backgroundColor: "rgba(217,217,217)"}}>
              {}
              <Button
                id="CardPostOperationUX-Button-226"
                onClick={props.addSecondary}
                style={{width: "100%", height: "100%", padding: "20px"}}>
                {props.languageUX === "en" ? "Add Secondary Diagnosis" : "เพิ่มการวินิจฉัยโรครอง"}
              </Button>
            </div>
            <div
              id="CardPostOperationUX-div-249"
              style={{width: "100%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "start" }}>
              
              <div
                className="ui form"
                id="CardPostOperationUX-div-250"
                style={{width: "100%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "start" }}>
                
                <div
                  id="CardPostOperationUX-div-251"
                  style={{fontWeight: "bold", width: "14%"}}>
                  
                  <label
                    id="CardPostOperationUX-label-253"
                    style={{fontWeight: "bold", width: "14%"}}>
                    {props.languageUX === "en" ? "Post-Diagnosis Detail" : "รายละเอียดหลังการวินิจฉัย"}
                  </label>
                </div>
                <div
                  id="CardPostOperationUX-div-252"
                  style={{width: "65%"}}>
                  
                  <TextArea
                    id="CardPostOperationUX-TextArea-254"
                    name="detail.post_diagnosis_remark"
                    onChange={props.onChangeData}
                    style={{margin: "0px 10px", width: "100%"}}
                    value={props.teamDetail?.detail?.post_diagnosis_remark || ""}>
                  </TextArea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-114"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-115"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"} }>
            
            <label
              id="CardPostOperationUX-label-122">
              {props.languageUX === "en" ? "Operation" : "การผ่าตัด"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-123"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", backgroundColor: "rgba(245,245,245)"}}>
            
            <div
              id="CardPostOperationUX-div-124"
              style={{margin: "5px 10px 0px 0px", padding: "10px", backgroundColor: "rgba(255,255,255)"}}>
              
              <div
                id="CardPostOperationUX-div-228"
                style={{display: props.hideOperatingTreatment?"none":""}}>
                {props.operationProcedure}
              </div>
              <div
                id="CardPostOperationUX-div-126"
                style={{ display: props.hideOperatingTreatment?"none":"flex", alignItems: "center" ,marginBottom: "15px", backgroundColor: "rgba(217,217,217)"}}>
                
                <Button
                  id="CardPostOperationUX-Button-229"
                  onClick={props.addProcedure}
                  style={{width: "100%", height: "100%", padding: "20px"}}>
                  {props.languageUX === "en" ? "Add a surgical item" : "เพิ่มรายการหัตถการ"}
                </Button>
              </div>
              <div
                className="ui form"
                id="CardPostOperationUX-div-255"
                style={{display: "flex", alignItems: "center", marginBottom: "1rem"}}>
                
                <label
                  id="CardPostOperationUX-label-256"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Other detail" : "รายละเอียดอื่น ๆ"}
                </label>
                <TextArea
                  id="CardPostOperationUX-TextArea-257"
                  name="post_operating_order_item.other_treatment"
                  onChange={props.onChangeData}
                  rows="5"
                  value={props.teamDetail?.post_operating_order_item?.other_treatment || ""}>
                </TextArea>
              </div>
              <div
                id="CardPostOperationUX-div-230">
                {props.operation}
              </div>
              <div
                id="CardPostOperationUX-div-129"
                style={{ display: "flex", alignItems: "center" ,marginBottom: "15px", backgroundColor: "rgba(217,217,217)"}}>
                {}
                <Button
                  id="CardPostOperationUX-Button-231"
                  onClick={props.addOperation}
                  style={{width: "100%", height: "100%", padding: "20px"}}>
                  {props.languageUX === "en" ? "Add Secondary Diagnosis ICD9" : "เพิ่มรหัสวินิจฉัย ICD-9"}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="ui form"
          id="CardPostOperationUX-div-152"
          style={{ display: "flex", alignItems: "start" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-153"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "13px 10px 0px 0px", fontWeight: "bold", alignItems: "start"}}>
            
            <label
              id="CardPostOperationUX-label-156">
              {props.languageUX === "en" ? "Implant" : "Implant"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-154"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "start"}}>
            
            <Checkbox
              checked={props.onImplantCheck}
              id="CardPostOperationUX-Checkbox-157"
              label={props.onImplantCheck ? "Yes" : "N/A"}
              name="post_implant.checked"
              onChange={props.onChangeImplantCheck}
              style={{fontWeight: "bold", minWidth: "max-content"}}
              toggle={true}>
            </Checkbox>
            <TextArea
              disabled={!props.onImplantCheck}
              id="CardPostOperationUX-TextArea-248"
              name="post_implant.value"
              onChange={props.onChangeImplantValue}
              rows={7}
              style={{width: "70%", margin: "0px 10px",}}
              value={props.onImplantValue || ""}>
            </TextArea>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-155"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-159"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-161">
              {props.languageUX === "en" ? "Specific Concern" : "ประเด็นเฉพาะ"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-160"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <Checkbox
              checked={props.teamDetail?.specific_concern?.checked || false}
              id="CardPostOperationUX-Checkbox-164"
              label={props.teamDetail?.specific_concern?.checked ? "Yes" : "N/A"}
              name="specific_concern.checked"
              onChange={props.onChangeData}
              style={{fontWeight: "bold", minWidth: "max-content"}}
              toggle={true}>
            </Checkbox>
            <Input
              disabled={props.teamDetail?.specific_concern?.checked ? false : true}
              id="CardPostOperationUX-Input-165"
              name="specific_concern.value"
              onChange={props.onChangeData}
              style={{width: "70%",  margin: "0px 10px",}}
              value={props.teamDetail?.specific_concern?.value || ""}>
            </Input>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-166"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-167"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-169">
              {props.languageUX === "en" ? "Type of wound" : "ประเภทของบาดแผล"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-168"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <Dropdown
              id="CardPostOperationUX-Dropdown-222"
              name="type_of_wound"
              onChange={props.onChangeData}
              options={props.woundOptions}
              selection={true}
              style={{width: "78%"}}
              value={props.teamDetail?.type_of_wound}>
            </Dropdown>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-171"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-172"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-174">
              {props.languageUX === "en" ? "Specimen" : "Specimen"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-173"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <div
              id="CardPostOperationUX-div-175"
              style={{display: "flex", alignItems: "center"}}>
              
              <Checkbox
                checked={props.teamDetail?.specimen?.checked || false}
                id="CardPostOperationUX-Checkbox-178"
                label={props.teamDetail?.specimen?.checked ? "Yes" : "N/A"}
                name="specimen.checked"
                onChange={props.onChangeData}
                style={{fontWeight: "bold", minWidth: "max-content"}}
                toggle="true">
              </Checkbox>
            </div>
            <div
              id="CardPostOperationUX-div-176"
              style={{width: "35%", display: "flex", alignItems: "center"}}>
              
              <Checkbox
                checked={props.teamDetail?.specimen?.isCyto || false}
                disabled={props.teamDetail?.specimen?.checked ? false : true}
                id="CardPostOperationUX-Checkbox-227"
                label={props.languageUX === "en" ? "CYTO" : "CYTO"}
                name="specimen.isCyto"
                onChange={props.onChangeData}
                style={{margin: "0px 10px",fontWeight: "bold",minWidth: "max-content"}}>
              </Checkbox>
              <Input
                disabled={!props.teamDetail?.specimen?.isCyto || false}
                fluid={true}
                id="CardPostOperationUX-Input-182"
                name="specimen.cyto"
                onChange={props.onChangeData}
                style={{margin: "0px 10px", width: "100%"}}
                value={props.teamDetail?.specimen?.cyto || ""}>
              </Input>
              <label
                id="CardPostOperationUX-label-181"
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "bottle" : "ขวด"}
              </label>
            </div>
            <div
              id="CardPostOperationUX-div-177"
              style={{width: "35%", display: "flex", alignItems: "center"}}>
              
              <Checkbox
                checked={props.teamDetail?.specimen?.isPatho || false}
                disabled={props.teamDetail?.specimen?.checked ? false : true}
                id="CardPostOperationUX-Checkbox-183"
                label={props.languageUX === "en" ? "PATHO" : "PATHO"}
                name="specimen.isPatho"
                onChange={props.onChangeData}
                style={{margin: "0px 10px",fontWeight: "bold", minWidth: "max-content"}}>
              </Checkbox>
              <Input
                disabled={!props.teamDetail?.specimen?.isPatho || false}
                fluid={true}
                id="CardPostOperationUX-Input-186"
                name="specimen.patho"
                onChange={props.onChangeData}
                style={{margin: "0px 10px", width: "100%"}}
                value={props.teamDetail?.specimen?.patho || ""}>
              </Input>
              <label
                id="CardPostOperationUX-label-185"
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "item" : "ชิ้น"}
              </label>
            </div>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-187"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-188"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-190">
              {props.languageUX === "en" ? "Blood Loss (ml.)" : "ปริมาณเลือดที่เสีย (มล.)"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-189"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <Input
              id="CardPostOperationUX-Input-191"
              name="blood_loss"
              onChange={props.onChangeData}
              style={{width: "78%"}}
              value={props.teamDetail?.blood_loss}>
            </Input>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-192"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-193"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-195">
              {props.languageUX === "en" ? "Tourniquet" : "อุปกรณ์รัดห้ามเลือด"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-194"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <Checkbox
              checked={props.teamDetail?.tourniquet?.checked || false}
              id="CardPostOperationUX-Checkbox-197"
              label={props.teamDetail?.tourniquet?.checked ? "Yes" : "N/A"}
              name="tourniquet.checked"
              onChange={props.onChangeData}
              toggle={true}>
            </Checkbox>
            <Input
              disabled={props.teamDetail?.tourniquet?.checked ? false : true}
              id="CardPostOperationUX-Input-198"
              name="tourniquet.value"
              onChange={props.onChangeData}
              style={{width: "70%", margin: "0px 10px",}}
              value={props.teamDetail?.tourniquet?.value || ""}>
            </Input>
          </div>
        </div>
        <div
          className="ui form"
          id="CardPostOperationUX-div-260"
          style={{ display: "flex", alignItems: "baseline" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-261"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-263">
              {props.languageUX === "en" ? "Operative Findings" : "สิ่งที่พบระหว่างการผ่าตัด"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-262"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <TextArea
              id="CardPostOperationUX-TextArea-264"
              name="detail.operative_findings"
              onChange={props.onChangeData}
              rows="5"
              style={{width: "100%", padding: "10px", resize: "none"}}
              value={props.teamDetail?.detail?.operative_findings || ""}>
            </TextArea>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-199"
          style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" ,padding: "5px 10px 0px 0px",margin: "5px 10px 0px 0px"}}>
          
          <Button
            color="teal"
            id="CardPostOperationUX-Button-202"
            onClick={props.openTemplate}
            style={{backgroundColor: "rgba(19,128,88)"}}>
            {props.languageUX === "en" ? "Template" : "Template"}
          </Button>
        </div>
        <div
          id="CardPostOperationUX-div-200"
          style={{ display: "flex", alignItems: "baseline" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-203"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-205">
              {props.languageUX === "en" ? "Procedure" : "กระบวนการรักษา"}
            </label>
          </div>
          <div
            className="ui form"
            id="CardPostOperationUX-div-204"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <TextArea
              id="CardPostOperationUX-TextArea-207"
              name="operative_note"
              onChange={props.onChangeData}
              rows="10"
              style={{width: "100%", padding: "10px", resize: "none"}}
              value={props.teamDetail?.operative_note}>
            </TextArea>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-265"
          style={{ display: "flex", alignItems: "baseline" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-266"
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label
              id="CardPostOperationUX-label-268">
              {props.languageUX === "en" ? "Complication" : "ภาวะแทรกซ้อน"}
            </label>
          </div>
          <div
            className="ui form"
            id="CardPostOperationUX-div-267"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <TextArea
              id="CardPostOperationUX-TextArea-269"
              name="detail.operative_complication"
              onChange={props.onChangeData}
              rows="10"
              style={{width: "100%", padding: "10px", resize: "none"}}
              value={props.teamDetail?.detail?.operative_complication || ""}>
            </TextArea>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-201"
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            id="CardPostOperationUX-div-208"
            style={{display: "flex", justifyContent: "flex-end", width: "10%", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
          </div>
          <div
            id="CardPostOperationUX-div-209"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
            
            <div
              id="CardPostOperationUX-div-242">
              
            </div>
            <div
              id="CardPostOperationUX-div-243">
              {props.onPrint}
            </div>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-212"
          style={{padding: "20px", backgroundColor: "rgba(245,245,245)", margin: "5px 10px 0px 0px"}}>
          
          <div
            id="CardPostOperationUX-div-214">
            
            <label
              id="CardPostOperationUX-label-216"
              style={{fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Surgical illustration" : "ภาพประกอบการผ่าตัด"}
            </label>
          </div>
          <div
            id="CardPostOperationUX-div-241"
            style={{padding: "10px 0px"}}>
            {props.imgDetail}
          </div>
          <div
            id="CardPostOperationUX-div-215">
            
            <Button
              color="blue"
              disabled={props.disabledUpload}
              id="CardPostOperationUX-Button-217"
              onClick={props.takePhoto}
              style={{marginRight: "10px" }}>
              {props.languageUX === "en" ? "Take Photo" : "Take Photo"}
            </Button>
            <Button
              color="blue"
              disabled={props.disabledUpload}
              id="CardPostOperationUX-Button-218"
              onClick={props.uploadImg}>
              {props.languageUX === "en" ? "Upload" : "Upload"}
            </Button>
          </div>
        </div>
        <div
          id="CardPostOperationUX-div-213"
          style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" ,padding: "5px 10px 0px 0px",margin: "15px 10px 0px 0px"}}>
          
          <div
            id="CardPostOperationUX-div-235">
            {props.buttonSave}
          </div>
          <div
            id="CardPostOperationUX-div-236"
            style={{margin: "0px 5px" ,display: "none"}}>
            
            <Button
              color="green"
              id="CardPostOperationUX-Button-239">
              {props.languageUX === "en" ? "Confirm" : "ยืนยัน"}
            </Button>
          </div>
          <div
            id="CardPostOperationUX-div-237"
            style={{display: "none"}}>
            
            <Button
              color="red"
              id="CardPostOperationUX-Button-240">
              {props.languageUX === "en" ? "Unconfirm" : "ยกเลิกการยืนยัน"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardPostOperationUX

export const screenPropsDefault = {"debug":true,"language":"TH","showSupplyList":false}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperation"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\", padding: \"20px\", backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"0px\", display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Operative Note",
          "valueEN": "Operative Note"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"22px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-3"
        },
        "size": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "hr",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-hr-5"
        }
      },
      "seq": 5,
      "void": true
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\", fontWeight: \"bold\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", width: \"25%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"20%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ผ่าตัด",
          "valueEN": "Date of Operation"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.operatingDetail?.incision_date"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-16"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"20%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาผ่าตัด",
          "valueEN": "Operative time"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-18"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "props.operatingDetail?.incision_datetime"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-19"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{width: \"60%\", paddingLeft: \"20px\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Dropdown",
      "parent": 21,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Dropdown-22"
        },
        "name": {
          "type": "value",
          "value": "swab_instrument_status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.swabOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.swab_instrument_status || \"\""
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "อุปกรณ์ Swab ",
          "valueEN": "Swab Instrument"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-24"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\", fontWeight: \"bold\" }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{width: \"60%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "ทีม",
          "valueEN": "Team"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-29"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-30"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Dropdown",
      "parent": 28,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Dropdown-31"
        },
        "name": {
          "type": "value",
          "value": "id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeTeam"
        },
        "options": {
          "type": "code",
          "value": "props.chiefSurgeonOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.id"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "hr",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-hr-32"
        }
      },
      "seq": 32,
      "void": true
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ช่วยศัลยแพทย์",
          "valueEN": "Assistant Surgeon"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-35"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "code",
          "value": "props.teamDetail?.assistant_surgeons_summary"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-40"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "props.teamDetail?.scrub_nurse_summary"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-44"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาล Scrub",
          "valueEN": "Scrub Nurse"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-45"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 48,
      "props": {
        "children": {
          "type": "code",
          "value": "props.teamDetail?.circulating_nurse_summary"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาล Circulation",
          "valueEN": "Circulation Nurse"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "code",
          "value": "props.teamDetail?.anesthesiologist_summary"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-54"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "วิสัญญีแพทย์",
          "valueEN": "Anesthesisologist"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-55"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "code",
          "value": "props.teamDetail?.anesthetist_summary"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-59"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "label",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาลวิสัญญี",
          "valueEN": "Anesthesia nurse"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-60"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-62"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", backgroundColor: \"rgba(255,255,255)\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "label",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยโรคก่อนการผ่าตัด",
          "valueEN": "Preoperative diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-64"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: \"5px\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-66"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยโรคหลัก",
          "valueEN": "Principle Diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-68"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-69"
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-71"
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "Medical Term",
          "valueEN": "Medical Term"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-73"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "label",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "ICD10 Term",
          "valueEN": "ICD10 Term"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-74"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "label",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "ICD10 Code",
          "valueEN": "ICD10 Code"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-75"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "label",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "โรคที่กำลังดำเนินอยู่",
          "valueEN": "Active Disease"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-76"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "Input",
      "parent": 69,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-77"
        },
        "name": {
          "type": "value",
          "value": "icd10_med_term"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePrePrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd10_med_term || \"\""
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Input",
      "parent": 70,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-78"
        },
        "name": {
          "type": "value",
          "value": "icd_term"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePrePrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd_term || \"\""
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "Input",
      "parent": 71,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-79"
        },
        "name": {
          "type": "value",
          "value": "icd_code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePrePrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd_code || \"\""
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "Checkbox",
      "parent": 72,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.active_disease || false"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Checkbox-80"
        },
        "name": {
          "type": "value",
          "value": "active_disease"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePreActive"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px 0 0\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Button",
      "parent": 72,
      "props": {
        "color": {
          "type": "value",
          "value": "teal"
        },
        "icon": {
          "type": "value",
          "value": "erase"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-81"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Button",
      "parent": 72,
      "props": {
        "color": {
          "type": "value",
          "value": "red"
        },
        "icon": {
          "type": "value",
          "value": "minus"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-82"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 0 0 10px\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-84"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"start\" }"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{width: \"65%\"}"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"15px\", backgroundColor: \"rgba(245,245,245)\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: \"5px\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"center\", width: \"100%\", height: \"100%\" , backgroundColor: \"rgba(217,217,217)\"}"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยโรคหลังการผ่าตัด",
          "valueEN": "Postoperative diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-98"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "label",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยโรคหลัก",
          "valueEN": "Principle Diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-99"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "label",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": "Medical Term",
          "valueEN": "Medical Term"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-104"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "label",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "ICD10 Term",
          "valueEN": "ICD10 Term"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-105"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "label",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": "ICD10 Code",
          "valueEN": "ICD10 Code"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-106"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "โรคที่กำลังดำเนินอยู่",
          "valueEN": "Active Disease"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-107"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "Input",
      "parent": 100,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-108"
        },
        "name": {
          "type": "value",
          "value": "icd10_med_term"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePostPrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_principal_diagnosis[0]?.icd10_med_term || \"\""
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "Input",
      "parent": 101,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-109"
        },
        "name": {
          "type": "value",
          "value": "icd_term"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePostPrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_principal_diagnosis[0]?.icd_term || \"\""
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Input",
      "parent": 102,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-110"
        },
        "name": {
          "type": "value",
          "value": "icd_code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePostPrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_principal_diagnosis[0]?.icd_code || \"\""
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Checkbox",
      "parent": 103,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.post_principal_diagnosis[0]?.active_disease || false"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Checkbox-111"
        },
        "label": {
          "type": "code",
          "value": ""
        },
        "name": {
          "type": "value",
          "value": "active_disease"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePostPrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px 0 0\"}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Button",
      "parent": 103,
      "props": {
        "color": {
          "type": "value",
          "value": "teal"
        },
        "icon": {
          "type": "value",
          "value": "erase"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-112"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearPrinciple"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Button",
      "parent": 103,
      "props": {
        "color": {
          "type": "value",
          "value": "red"
        },
        "icon": {
          "type": "value",
          "value": "minus"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-113"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearPrinciple"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 0 0 10px\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-114"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-115"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"} "
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "label",
      "parent": 115,
      "props": {
        "children": {
          "type": "value",
          "value": "การผ่าตัด",
          "valueEN": "Operation"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-122"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-123"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", backgroundColor: \"rgba(245,245,245)\"}"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-124"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px 10px 0px 0px\", padding: \"10px\", backgroundColor: \"rgba(255,255,255)\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-126"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideOperatingTreatment?\"none\":\"flex\", alignItems: \"center\" ,marginBottom: \"15px\", backgroundColor: \"rgba(217,217,217)\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-129"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,marginBottom: \"15px\", backgroundColor: \"rgba(217,217,217)\"}"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-152"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"start\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-153"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"13px 10px 0px 0px\", fontWeight: \"bold\", alignItems: \"start\"}"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"start\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-155"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "label",
      "parent": 153,
      "props": {
        "children": {
          "type": "value",
          "value": "Implant",
          "valueEN": "Implant"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-156"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "Checkbox",
      "parent": 154,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.onImplantCheck"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Checkbox-157"
        },
        "label": {
          "type": "code",
          "value": "props.onImplantCheck ? \"Yes\" : \"N/A\""
        },
        "name": {
          "type": "value",
          "value": "post_implant.checked"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeImplantCheck"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-159"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-160"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "label",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเด็นเฉพาะ",
          "valueEN": "Specific Concern"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-161"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "Checkbox",
      "parent": 160,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.specific_concern?.checked || false"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Checkbox-164"
        },
        "label": {
          "type": "code",
          "value": "props.teamDetail?.specific_concern?.checked ? \"Yes\" : \"N/A\""
        },
        "name": {
          "type": "value",
          "value": "specific_concern.checked"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "Input",
      "parent": 160,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.teamDetail?.specific_concern?.checked ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-165"
        },
        "name": {
          "type": "value",
          "value": "specific_concern.value"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70%\",  margin: \"0px 10px\",}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.specific_concern?.value || \"\""
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-166"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "div",
      "parent": 166,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-167"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "div",
      "parent": 166,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-168"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "label",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทของบาดแผล",
          "valueEN": "Type of wound"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-169"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-171"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-172"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-173"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "label",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": "Specimen",
          "valueEN": "Specimen"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-174"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-175"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-176"
        },
        "style": {
          "type": "code",
          "value": "{width: \"35%\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-177"
        },
        "style": {
          "type": "code",
          "value": "{width: \"35%\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "Checkbox",
      "parent": 175,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.checked || false"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Checkbox-178"
        },
        "label": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.checked ? \"Yes\" : \"N/A\""
        },
        "name": {
          "type": "value",
          "value": "specimen.checked"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        },
        "toggle": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "label",
      "parent": 176,
      "props": {
        "children": {
          "type": "value",
          "value": "ขวด",
          "valueEN": "bottle"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-181"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "Input",
      "parent": 176,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.teamDetail?.specimen?.isCyto || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-182"
        },
        "name": {
          "type": "value",
          "value": "specimen.cyto"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.cyto || \"\""
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 183,
      "name": "Checkbox",
      "parent": 177,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.isPatho || false"
        },
        "disabled": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.checked ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Checkbox-183"
        },
        "label": {
          "type": "value",
          "value": "PATHO",
          "valueEN": "PATHO"
        },
        "name": {
          "type": "value",
          "value": "specimen.isPatho"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\",fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "label",
      "parent": 177,
      "props": {
        "children": {
          "type": "value",
          "value": "ชิ้น",
          "valueEN": "item"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-185"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "Input",
      "parent": 177,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.teamDetail?.specimen?.isPatho || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-186"
        },
        "name": {
          "type": "value",
          "value": "specimen.patho"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.patho || \"\""
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 187,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-187"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "div",
      "parent": 187,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-188"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 187,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-189"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "label",
      "parent": 188,
      "props": {
        "children": {
          "type": "value",
          "value": "ปริมาณเลือดที่เสีย (มล.)",
          "valueEN": "Blood Loss (ml.)"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-190"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "Input",
      "parent": 189,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-191"
        },
        "name": {
          "type": "value",
          "value": "blood_loss"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width: \"78%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.blood_loss"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-192"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 193,
      "name": "div",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-193"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "div",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-194"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "label",
      "parent": 193,
      "props": {
        "children": {
          "type": "value",
          "value": "อุปกรณ์รัดห้ามเลือด",
          "valueEN": "Tourniquet"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-195"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "Checkbox",
      "parent": 194,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.tourniquet?.checked || false"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Checkbox-197"
        },
        "label": {
          "type": "code",
          "value": "props.teamDetail?.tourniquet?.checked ? \"Yes\" : \"N/A\""
        },
        "name": {
          "type": "value",
          "value": "tourniquet.checked"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 198,
      "name": "Input",
      "parent": 194,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.teamDetail?.tourniquet?.checked ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Input-198"
        },
        "name": {
          "type": "value",
          "value": "tourniquet.value"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70%\", margin: \"0px 10px\",}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.tourniquet?.value || \"\""
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": null,
      "id": 199,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-199"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"flex-end\" ,padding: \"5px 10px 0px 0px\",margin: \"5px 10px 0px 0px\"}"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": null,
      "id": 200,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-200"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"baseline\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": null,
      "id": 201,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-201"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 202,
      "name": "Button",
      "parent": 199,
      "props": {
        "children": {
          "type": "value",
          "value": "Template",
          "valueEN": "Template"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-202"
        },
        "onClick": {
          "type": "code",
          "value": "props.openTemplate"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(19,128,88)\"}"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": null,
      "id": 203,
      "name": "div",
      "parent": 200,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-203"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": null,
      "id": 204,
      "name": "div",
      "parent": 200,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-204"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": null,
      "id": 205,
      "name": "label",
      "parent": 203,
      "props": {
        "children": {
          "type": "value",
          "value": "กระบวนการรักษา",
          "valueEN": "Procedure"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-205"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 207,
      "name": "TextArea",
      "parent": 204,
      "props": {
        "disabled": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-TextArea-207"
        },
        "name": {
          "type": "value",
          "value": "operative_note"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "10"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding: \"10px\", resize: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.operative_note"
        }
      },
      "seq": 207,
      "void": true
    },
    {
      "from": null,
      "id": 208,
      "name": "div",
      "parent": 201,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-208"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", width: \"10%\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": null,
      "id": 209,
      "name": "div",
      "parent": 201,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-209"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": null,
      "id": 212,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-212"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"20px\", backgroundColor: \"rgba(245,245,245)\", margin: \"5px 10px 0px 0px\"}"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": null,
      "id": 213,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-213"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"flex-end\" ,padding: \"5px 10px 0px 0px\",margin: \"15px 10px 0px 0px\"}"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": null,
      "id": 214,
      "name": "div",
      "parent": 212,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-214"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "div",
      "parent": 212,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-215"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 216,
      "name": "label",
      "parent": 214,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาพประกอบการผ่าตัด",
          "valueEN": "Surgical illustration"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-216"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 217,
      "name": "Button",
      "parent": 215,
      "props": {
        "children": {
          "type": "value",
          "value": "Take Photo",
          "valueEN": "Take Photo"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledUpload"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-217"
        },
        "onClick": {
          "type": "code",
          "value": "props.takePhoto"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 218,
      "name": "Button",
      "parent": 215,
      "props": {
        "children": {
          "type": "value",
          "value": "Upload",
          "valueEN": "Upload"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledUpload"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-218"
        },
        "onClick": {
          "type": "code",
          "value": "props.uploadImg"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 222,
      "name": "Dropdown",
      "parent": 168,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Dropdown-222"
        },
        "name": {
          "type": "value",
          "value": "type_of_wound"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.woundOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"78%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.type_of_wound"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": null,
      "id": 223,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-223"
        },
        "style": {
          "type": "code",
          "value": "{...(props.secondary_style || {})}"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": null,
      "id": 224,
      "name": "label",
      "parent": 223,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยโรครอง",
          "valueEN": "Secondary Diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-224"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 224,
      "void": false
    },
    {
      "from": null,
      "id": 225,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "code",
          "value": "props.secondaryDiagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-225"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 226,
      "name": "Button",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มการวินิจฉัยโรครอง",
          "valueEN": "Add Secondary Diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-226"
        },
        "onClick": {
          "type": "code",
          "value": "props.addSecondary"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", padding: \"20px\"}"
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 227,
      "name": "Checkbox",
      "parent": 176,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.isCyto || false"
        },
        "disabled": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.checked ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Checkbox-227"
        },
        "label": {
          "type": "value",
          "value": "CYTO",
          "valueEN": "CYTO"
        },
        "name": {
          "type": "value",
          "value": "specimen.isCyto"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\",fontWeight: \"bold\",minWidth: \"max-content\"}"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 228,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": "props.operationProcedure"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-228"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideOperatingTreatment?\"none\":\"\"}"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 229,
      "name": "Button",
      "parent": 126,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มรายการหัตถการ",
          "valueEN": "Add a surgical item"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-229"
        },
        "onClick": {
          "type": "code",
          "value": "props.addProcedure"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", padding: \"20px\"}"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": null,
      "id": 230,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": "props.operation"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-230"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 231,
      "name": "Button",
      "parent": 129,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มรหัสวินิจฉัย ICD-9",
          "valueEN": "Add Secondary Diagnosis ICD9"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-231"
        },
        "onClick": {
          "type": "code",
          "value": "props.addOperation"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", padding: \"20px\"}"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": null,
      "id": 233,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-233"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.openSearchPostPrincipal ? \"block\" : \"none\", zIndex: 100,  width: \"calc(100% - 20px)\", } "
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 234,
      "name": "Table",
      "parent": 233,
      "props": {
        "data": {
          "type": "code",
          "value": "props.searchPostProcedures"
        },
        "defaultPageSize": {
          "type": "code",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": "props.postPrincipleDiagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Table-234"
        },
        "keys": {
          "type": "value",
          "value": "medterm,icdterm,icdcode"
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"150px\" }"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": null,
      "id": 235,
      "name": "div",
      "parent": 213,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-235"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": null,
      "id": 236,
      "name": "div",
      "parent": 213,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-236"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 5px\" ,display: \"none\"}"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": null,
      "id": 237,
      "name": "div",
      "parent": 213,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-237"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 239,
      "name": "Button",
      "parent": 236,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยัน",
          "valueEN": "Confirm"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-239"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 240,
      "name": "Button",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกการยืนยัน",
          "valueEN": "Unconfirm"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Button-240"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": null,
      "id": 241,
      "name": "div",
      "parent": 212,
      "props": {
        "children": {
          "type": "code",
          "value": "props.imgDetail"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-241"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 0px\"}"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": null,
      "id": 242,
      "name": "div",
      "parent": 209,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-242"
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": null,
      "id": 243,
      "name": "div",
      "parent": 209,
      "props": {
        "children": {
          "type": "code",
          "value": "props.onPrint"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-243"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": null,
      "id": 244,
      "name": "label",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-244"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 245,
      "name": "TextArea",
      "parent": 90,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-TextArea-245"
        },
        "name": {
          "type": "value",
          "value": "detail.post_op_pre_diagnosis_remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.detail?.post_op_pre_diagnosis_remark|| \"\""
        }
      },
      "seq": 245,
      "void": true
    },
    {
      "from": null,
      "id": 246,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-246"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", width: \"14%\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 247,
      "name": "label",
      "parent": 246,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดก่อนการวินิจฉัย",
          "valueEN": "Pre-Diagnosis Detail"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-247"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", width: \"14%\"}"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 248,
      "name": "TextArea",
      "parent": 154,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.onImplantCheck"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-TextArea-248"
        },
        "name": {
          "type": "value",
          "value": "post_implant.value"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeImplantValue"
        },
        "readOnly": {
          "type": "code",
          "value": ""
        },
        "rows": {
          "type": "code",
          "value": "7"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70%\", margin: \"0px 10px\",}"
        },
        "value": {
          "type": "code",
          "value": "props.onImplantValue || \"\""
        }
      },
      "seq": 248,
      "void": true
    },
    {
      "from": null,
      "id": 249,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-249"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"start\" }"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": null,
      "id": 250,
      "name": "div",
      "parent": 249,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-250"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"start\" }"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 250,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-251"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", width: \"14%\"}"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "div",
      "parent": 250,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-252"
        },
        "style": {
          "type": "code",
          "value": "{width: \"65%\"}"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "label",
      "parent": 251,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดหลังการวินิจฉัย",
          "valueEN": "Post-Diagnosis Detail"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-253"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", width: \"14%\"}"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 254,
      "name": "TextArea",
      "parent": 252,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-TextArea-254"
        },
        "name": {
          "type": "value",
          "value": "detail.post_diagnosis_remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.detail?.post_diagnosis_remark || \"\""
        }
      },
      "seq": 254,
      "void": true
    },
    {
      "from": null,
      "id": 255,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-255"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginBottom: \"1rem\"}"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 256,
      "name": "label",
      "parent": 255,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดอื่น ๆ",
          "valueEN": "Other detail"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-256"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 257,
      "name": "TextArea",
      "parent": 255,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-TextArea-257"
        },
        "name": {
          "type": "value",
          "value": "post_operating_order_item.other_treatment"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "5"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_operating_order_item?.other_treatment || \"\""
        }
      },
      "seq": 257,
      "void": true
    },
    {
      "from": null,
      "id": 258,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-258"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.openSearchPrePrincipal ? \"block\" : \"none\", zIndex: 100,  width: \"calc(100% - 20px)\", } "
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 259,
      "name": "Table",
      "parent": 258,
      "props": {
        "data": {
          "type": "code",
          "value": "props.searchPostProcedures"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.prePrincipleDiagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-Table-259"
        },
        "keys": {
          "type": "value",
          "value": "medterm,icdterm,icdcode"
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "name": {
          "type": "value",
          "value": "test"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"150px\" }"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": null,
      "id": 260,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-260"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"baseline\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": null,
      "id": 261,
      "name": "div",
      "parent": 260,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-261"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 262,
      "name": "div",
      "parent": 260,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-262"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": null,
      "id": 263,
      "name": "label",
      "parent": 261,
      "props": {
        "children": {
          "type": "value",
          "value": "สิ่งที่พบระหว่างการผ่าตัด",
          "valueEN": "Operative Findings"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-263"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 264,
      "name": "TextArea",
      "parent": 262,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-TextArea-264"
        },
        "name": {
          "type": "value",
          "value": "detail.operative_findings"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "5"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding: \"10px\", resize: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.detail?.operative_findings || \"\""
        }
      },
      "seq": 264,
      "void": true
    },
    {
      "from": null,
      "id": 265,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-265"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"baseline\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": null,
      "id": 266,
      "name": "div",
      "parent": 265,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-266"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": null,
      "id": 267,
      "name": "div",
      "parent": 265,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-div-267"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": null,
      "id": 268,
      "name": "label",
      "parent": 266,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาวะแทรกซ้อน",
          "valueEN": "Complication"
        },
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-label-268"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 269,
      "name": "TextArea",
      "parent": 267,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperationUX-TextArea-269"
        },
        "name": {
          "type": "value",
          "value": "detail.operative_complication"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "10"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding: \"10px\", resize: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.detail?.operative_complication || \"\""
        }
      },
      "seq": 269,
      "void": true
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": false,
  "name": "CardPostOperationUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "debug": true,
    "language": "TH",
    "showSupplyList": false
  },
  "width": 75
}

*********************************************************************************** */
